import globalStyles from '../../../../global.less'
import styles from '../index.less'
const getSty = (str: string) => styles[str]
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty('KeyPoint')} ${cla ? styles[cla] : ''}`}>
    {str}
  </span>
)
const fontBoldUnderline = (str: string) => (
  <span className={`${getSty('KeyPoint')} ${getSty('underline')}`}>{str}</span>
)
export default function ProtocolDPAUS() {
  return (
    <div className={`${globalStyles['container']} ${getSty('protocol')}`}>
      <h2 className={getSty('title-h2')}>
        Xiaomi Channel Data Privacy Agreement
      </h2>
      <p className={getSty('explain-title')}>General Provisions</p>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>Integrity of This Agreement</h5>
            <p className={getSty('explain')}>
              This Agreement contains these {fonSizeBold('General Provisions')},
              the below Xiaomi Channel Privacy Notice{' '}
              {fonSizeBold('(“Privacy Notice”)')} and the below Xiaomi Channel
              Data Processing Agreement{' '}
              {fonSizeBold(
                '(“DPA” and not to be confused with “this Agreement” as defined inthis paragraph),'
              )}{' '}
              all three of which form an integral part of this Agreement.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>
              Your Consent and Retailer’s Authorization
            </h5>
            <p className={getSty('explain')}>
              {fonSizeBold(
                'By your first acceptance of this Agreement in Xiaomi Channel, you consent that:'
              )}
            </p>
            <p className={getSty('explain')}>
              (1) Xiaomi may process your personal data as set out in the
              Privacy Notice;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '(2) if this is also the first acceptance of the DPA by any staff member of the Retailer'
              )}
              {''} for whom you use Xiaomi Channel {fonSizeBold('(“Retailer”)')}{' '}
              and who participates inXiaomi’s incentive program for sell-outs to
              end consumers, {fontBoldUnderline('you:')}
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline(
                '(i) represent and warrant you are duly authorized by law or Retailer to bind it to the DPA and to instruct Xiaomi on behalf of Retailer to process personal data pursuant to the DPA,'
              )}{' '}
              which authorizes Xiaomi to process personal data on behalf
              of Retailer as set out therein;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('(ii) hereby bind Retailer to the DPA; and') }
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('(iii) acknowledge any instructions to Xiaomi, from you and any other staff members of Retailer authorized as set out in (2)(i), , to process personal data are such instructions from Retailer,')}
              {fontBoldUnderline(' regardless of whether these instructions are by word or conduct (such as transmitting personal data to Xiaomi in XiaomiChannel) and express or otherwise, but silence is never an instruction;')}
            </p>
            <p className={getSty('explain')}>
              (3) your acceptance of this Agreement has the same legal force as
              a signature thereof duly executed by you on paper;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '(4) it is no defense for you or Retailer against application of this Agreement to claim any failure to:'
              )}
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(i) read, understand and accept it in its entirety; or') }
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(ii) duly obtain authorization from Retailer to bind it to the DPA; and') }
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(5) you shall indemnify and hold Xiaomi harmless at your own cost')}
              {fonSizeBold(
                ' from and against all allegations, claims, actions, suits, demands, damages, liabilities, obligations, losses, settlements, judgments, costs and expenses'
              )}
              {fontBoldUnderline(' that arise out of, relate to or result from your omission or misrepresentation, knowing or otherwise, of Retailer’s authorization as set out in (2)(i) above (or of its defects or nonexistence).')}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>
              Severability of This Agreement
            </h5>
            <p className={getSty('explain')}>
              If any provision of this Agreement is rendered void, unlawful or
              unenforceable in any respect, whether against one or more of
              Xiaomi, you and Retailer (each a {fonSizeBold('“Party”')} and any
              combination of which {fonSizeBold('“Parties”,')} except as
              otherwise provided in the DPA below), the validity, lawfulness and
              enforceability of the remaining provisions (and such aforesaid
              provision against the other Parties) shall not in any way be
              affected or impaired thereby.
            </p>
          </li>
        </ol>
      </div>
      <p className={getSty('explain-title')}>Xiaomi Channel Privacy Notice</p>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
          Xiaomi Channel provides you with sales performance display, incentive
          calculation and other services (including any other forms of service
          provision that may arise in the future). To fulfill the functions, we
          may collect, process, and share your personal data as below:
        </p>
        <h5 className={getSty('explain')}>Employee Authentication</h5>
        <p className={getSty('explain')}>
          Xiaomi Channel is only available to certain personnel (e.g., staff
          authorized to work on Retailer’s store premises) and requires identity
          verification to display information in, and support your use of, Xiaomi
          Channel based on your user permissions, for which we{' '}
          {fonSizeBold('("Xiaomi")')} need to collect your{' '}
          {fonSizeBold(
            'Xiaomi Account information (including Xiaomi Account ID), name, mobile phone number, email address'
          )}{' '}
          voluntarily provided by you.
        </p>
        <p className={getSty('explain')}>
          {fonSizeBold(
            'The legal basis for these activities of processing your personal data is your consent.'
          )}
        </p>
      </div>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
          In addition, we will continue to use the above personal data and other
          personal data you provide to us for purposes such as shop management
          and human resources management.
        </p>
        <p className={getSty('explain')}>
          Please be assured that when we use your personal data, we will
          strictly comply with the applicable law, and will only process the
          minimum amount of personal data necessary.
        </p>
        <p className={getSty('explain')}>
          Please refer to our Privacy Policy at{' '}
          <a
            href='https://privacy.mi.com/all/languages'
            target='_blank'
            rel='noopener noreferrer'
          >
            https://privacy.mi.com/all/languages
          </a>{' '}
          for more information on how we process your personal data.
        </p>
        <h5 className={getSty('explain')}>
          Xiaomi Channel Data Processing Agreement
        </h5>
      </div>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>Purpose</h5>
            <p className={getSty('explain')}>
              This DPA is entered into by and between only Xiaomi and Retailer
              (each a {fonSizeBold('“Party”')}and jointly{' '}
              {fonSizeBold('“the Parties”)')} and to the exclusion of the user
              previously referred to as“you”.{' '}
              {fonSizeBold(
                'Xiaomi does not knowingly process personal data of the end consumer for its own purposes, and in the event that Retailer instructs it to process such personal   data,   the   processing   shall   be   subject   to   this   DPA,   on   behalf   of Retailer, and for Retailer’s instructed purposes only.The Parties understand that wherever this DPA provides below for processing of personal data, the processing shall be on the condition that Retailer instructs Xiaomi to process personal data of the end consumer.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Roles and Compliance</h5>
            <p className={getSty('explain')}>
              2.1 The Parties acknowledge that Retailer act as the data
              controller and Xiaomi actas the data processor who process certain
              personal data on behalf of Retailer under the applicable data
              protection laws.
            </p>
            <p className={getSty('explain')}>
              2.2 For the purposes of this DPA, “data controller” refers to the
              Party who decides the purposes and means of processing personal
              data, and “data processor” the Party who processes personal data on
              behalf of the data controller.
            </p>
            <p className={getSty('explain')}>
              2.3 Xiaomi shall process personal data on behalf of Retailer in
              accordance with this DPA and the lawful instructions of Retailer.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.4   Retailer   shall   ensure   that   its   instructions   at   all   times   comply   with   all applicable data protection laws.'
              )}{' '}
              Xiaomi will inform Retailer without undue delay if it becomes aware
              or reasonably believes that the instructions infringe any
              applicable data protection laws, {fonSizeBold('but no failure by Xiaomi to notify Retailer shall affect Retailer’s responsibility and liability for its instructions.') }
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.5 Retailer shall ensure that the data processing activities of Xiaomi have the appropriate lawful basis.'
              )}
            </p>
            <p className={getSty('explain')}>
              2.6 Xiaomi will take necessary steps according to Retailer’s
              instructions, to assist Retailer to comply with its obligations
              under the data protection laws.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.7 Retailer shall independently undertake claims or losses arising from its non-compliance with the obligations of the data controller and applicable data protection laws.'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('2.8 Retailer is hereby informed that,')} as any
              personal data of the end consumer associated with a Xiaomi product
              is data valuable to Xiaomi in itself,{' '}
              {fonSizeBold(
                'Retailer shallnot share the such personal data with any third party without the written consent of Xiaomi.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Data Subject’s Rights</h5>
            <p className={getSty('explain')}>
              3.1{' '}
              {fonSizeBold(
                'Retailer shall be solely responsible for compliance with any obligations concerning requests to exercise data subject’s rights under the applicable data protection laws.'
              )}{' '}
              Xiaomi shall reasonably assist Retailer with appropriate
              technical and organizational measures for the fulfilment of
              Retailer’s obligations to respond to such requests.
            </p>
            <p className={getSty('explain')}>
              3.2 Xiaomi shall inform Retailer without undue delay following the
              receipt of the request to exercise a data subject’s right, together
              with the additional relevant information needed to address the
              request.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Data Breach</h5>
            <p className={getSty('explain')}>Each Party: </p>
            <p className={getSty('explain')}>
              4.1 will promptly notify the other Party to take measures against
              any breach of security related to the personal data under its
              responsibility that leads or may lead to accidental, unauthorized
              or other unlawful access, transmission, interception,
              use,disclosure, alteration, combination, destruction, loss or
              other processing of personal data{' '}
              {fonSizeBold('(each breach as such a “Data Breach”),')} and
            </p>
            <p className={getSty('explain')}>
              4.2 shall reasonably cooperate with the other Party and take
              reasonable steps to assist in the investigation, mitigation and
              remediation of the Data Breach.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Security</h5>
            <p className={getSty('explain')}>Each Party shall:</p>
            <p className={getSty('explain')}>
              5.1 have in place appropriate technical and organizational
              measures in accordance with all applicable data protection laws to
              protect the personal data against accidental  or unlawful
              destruction, loss or damage, alteration, unauthorized disclosure
              or access, and against all other unlawful forms of processing;
            </p>
            <p className={getSty('explain')}>
              5.2 take all necessary steps to ensure that only authorized
              employees for the purpose of facilitating its obligations under
              this DPA have access to the personaldata;
            </p>
            <p className={getSty('explain')}>
              5.3 ensure that each employee who has access to the personal data
              understands its obligations under this DPA and all applicable data
              protection laws; and
            </p>
            <p className={getSty('explain')}>
              5.4 ensure the reliability of any employees who access the
              personal data and ensure that such personnel have undergone
              appropriate training in the protection of personal data and have
              entered into confidentiality provisions in relation to the
              processing of personal data.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Indemnity</h5>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '6.1 Each Party shall indemnify and hold the other Party harmless from and against   all'
              )}{' '}
              allegations, claims, actions, suits, demands, damages,
              liabilities, obligations, losses, settlements, judgments, costs
              and expenses (including without limitation lawyers’ fees and costs){' '}
              {fonSizeBold(
                'that arise out of, relate to or result from any act or omission of the defaulting Party.'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '6.2 In no event shall Xiaomi be liable for damages in excess of the contractual fees paid by Retailer under this Agreement.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>Termination</h5>
            <p className={getSty('explain')}>
              Without prejudice to any other rights or remedies it may have
              (whether under thisDPA or at law),{' '}
              {fonSizeBold('either Party may terminate this DPA immediately')}{' '}
              by serving written notice on the other Party {fonSizeBold('if:')}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.1 the other Party commits a breach of any material obligation under this DPA and, in case of a remediable breach, fails to remedy the breach after receiving 30 (thirty) calendar days’ written notice to do so; or'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.2 the Xiaomi Channel Platform Terms and Conditions is duly terminated between the Parties.'
              )}
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}
